/** Refresh token ve oturum anlık görüntüsü: remember-me → localStorage, değilse sessionStorage. */
import type { LoginResponse } from '@/shared/types/api';
import { impersonation } from './impersonation';

const RT_KEY = 'octo.web.rt';
const SNAPSHOT_KEY = 'octo.web.session';
const REMEMBER_KEY = 'octo.web.remember';

export interface SessionSnapshot {
  user: LoginResponse;
  connectionId: string | null;
  connectionName: string | null;
  sessionId: string;
  savedAt: number;
}

// Taklit sekmesi (#64) yalnız kendi sessionStorage'ını kullanır: yöneticinin localStorage'daki
// oturumunu ne okur ne siler.
function stores(): Storage[] {
  try {
    return impersonation.isTab() ? [sessionStorage] : [localStorage, sessionStorage];
  } catch {
    return [];
  }
}

function pick(remember: boolean): Storage | null {
  try {
    return remember && !impersonation.isTab() ? localStorage : sessionStorage;
  } catch {
    return null;
  }
}

export const tokenStorage = {
  isRemembered(): boolean {
    if (impersonation.isTab()) return false;
    try {
      return localStorage.getItem(REMEMBER_KEY) === '1';
    } catch {
      return false;
    }
  },
  setRemembered(v: boolean) {
    if (impersonation.isTab()) return;
    try {
      if (v) localStorage.setItem(REMEMBER_KEY, '1');
      else localStorage.removeItem(REMEMBER_KEY);
    } catch {
      /* noop */
    }
  },
  getRefreshToken(): string | null {
    for (const s of stores()) {
      const v = s.getItem(RT_KEY);
      if (v) return v;
    }
    return null;
  },
  setRefreshToken(token: string | null, remember: boolean) {
    for (const s of stores()) s.removeItem(RT_KEY);
    if (token) pick(remember)?.setItem(RT_KEY, token);
  },
  getSnapshot(): SessionSnapshot | null {
    for (const s of stores()) {
      const raw = s.getItem(SNAPSHOT_KEY);
      if (raw) {
        try {
          return JSON.parse(raw) as SessionSnapshot;
        } catch {
          s.removeItem(SNAPSHOT_KEY);
        }
      }
    }
    return null;
  },
  setSnapshot(snap: SessionSnapshot | null, remember: boolean) {
    for (const s of stores()) s.removeItem(SNAPSHOT_KEY);
    if (snap) pick(remember)?.setItem(SNAPSHOT_KEY, JSON.stringify(snap));
  },
  clear() {
    for (const s of stores()) {
      s.removeItem(RT_KEY);
      s.removeItem(SNAPSHOT_KEY);
    }
  },
};
